import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import { Modal, Spinner } from "react-bootstrap";
import sharedModalStyles from "assets/shared-stylesheets/modal.module.css";
import { Bet } from "interfaces/bet";
import { sparketBlack } from "utils/constants";
import Content from "./content";
import ConfettiExplosion from "react-confetti-explosion";
import { useAppSelector } from "state/hooks";
import { getGroupStyles, getTextColor } from "state/slices/group-slice";
import { useState } from "react";
import {
  getContestById,
  getContestEntryById,
  getContestIdByEntryId,
  getEntryRefreshLoadingState,
  getFullContestEntryDetailsById,
} from "state/slices/contests-slice.ts";
import { X } from "react-bootstrap-icons";
import { isBasicContest, isPickPerPoolContest } from "interfaces/leaderboard/contest";

interface Props {
  bet: Bet;
  close: () => void;
}

const SuccessfulBetModal = ({ bet, close }: Props) => {
  const primaryColor = useAppSelector(getGroupStyles).primary_color;
  const textColorValue = useAppSelector(getTextColor);

  const [isExploding, setIsExploding] = useState(true);

  const contestEntryId = bet.contest_entry_id;

  const contestEntry = useAppSelector(state => getContestEntryById(state, contestEntryId));
  const contestId = useAppSelector(state => getContestIdByEntryId(state, contestEntryId ?? ""));
  const contest = useAppSelector(state => getContestById(state, contestId));
  const isBasic = isBasicContest(contest);
  const fullContestEntryDetails = useAppSelector(state => getFullContestEntryDetailsById(state, contestEntryId));
  const entryRefreshLoadingState = useAppSelector(state => getEntryRefreshLoadingState(state, contestEntryId));
  const totalPicksMade = fullContestEntryDetails?.bets.length;
  // The bets fetch and the entry refresh are two independent dispatches; wait
  // for both before rendering so we never flash stale picks_made counts.
  const betsFetchIncludesThisBet = !!fullContestEntryDetails?.bets.some(b => b.id === bet.id);
  const entryRefreshDone = entryRefreshLoadingState === "succeeded" || entryRefreshLoadingState === "failed";

  return (
    <div>
      <Modal onHide={close} style={{ borderRadius: 20 }} show centered>
        <Modal.Title
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: primaryColor,
          }}
          className={sharedModalStyles.modalTitle}
        >
          <BlockyHeavyText style={{ color: textColorValue }}>
            Pick Confirmed
          </BlockyHeavyText>
          <X
            size={40}
            style={{
              position: "absolute",
              top: "50%",
              right: "15px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: textColorValue,
            }}
            onClick={close}
          />
        </Modal.Title>
        <Modal.Body style={{ backgroundColor: sparketBlack }}>
          {contestEntryId && (!contestEntry || !betsFetchIncludesThisBet || !entryRefreshDone) ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
              <Spinner animation="border" variant="light" />
            </div>
          ) : (
            <Content bet={bet} contestEntry={contestEntry} totalPicksMade={totalPicksMade} isBasic={isBasic} isPickPerPool={isPickPerPoolContest(contest)} />
          )}
        </Modal.Body>
      </Modal>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
        }}
      >
        {isExploding && (
          <ConfettiExplosion
            onComplete={() => {
              setIsExploding(false);
            }}
            zIndex={1001}
            particleCount={400}
            duration={3000}
            width={1500}
            style={{
              position: "absolute",
              top: "30%",
              left: "50%",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SuccessfulBetModal;
